
import { defineComponent, reactive } from 'vue'
import TitleCom from '@/components/TitleCom/index.vue'
import FlowItem from './flow-item.vue'
import { flowChartList } from './source'

export default defineComponent({
  components: {
    TitleCom,
    FlowItem
  },
  setup() {
    return {
      flowChartList: reactive(flowChartList)
    }
  }
})
